// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.
/**
 * Applies a theme to the document. With "system", the data-theme attribute is removed
 * and the prefers-color-scheme rules in tokens.gen.css decide.
 */
export function applyTheme(preference, root = document.documentElement) {
    if (preference === "system") {
        root.removeAttribute("data-theme");
    }
    else {
        root.setAttribute("data-theme", preference);
    }
}
/** The theme currently in effect for root. */
export function resolvedTheme(root = document.documentElement) {
    const forced = root.getAttribute("data-theme");
    if (forced === "light" || forced === "dark")
        return forced;
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
//# sourceMappingURL=theme.js.map